<template>
  <div class="liu">
    <!-- title -->
    <mt-header fixed title="奖励明细" class="title2">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <!-- 正文 -->
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <div class="task-detail-table header-next" v-for="(item, index) in myData.list" :key="index">
        <div class="detail-table-bodyer">
          <div class="detail-title">
            <span class="title">{{ item.rewardMsg }}</span>
            <span class="money">+{{ item.rewardMoney|num }}</span>
          </div>
          <div class="detail-date">
            <span class="date">{{ item.insertDate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ShowTaskRewardLogListMember } from '@/api/agent';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'TaskRewardSettingDetail',
  data() {
    return {
      // 列表信息
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        pageNum: 1,
        pageSize: 10,
        agentId: '',
        sortType: 4, // 筛选方式，4是从最新的数据开始显示
        findDate: '',
      },
      day: '', // 当天日期
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getMyData();
      // 显示当天的时间
      this.day = this.$route.query.date;
    },
    // 通过接口获取数据
    getMyData() {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.findDate = `${this.$route.query.date} 00:00:00`;
      this.myParam.agentId = `${this.$route.query.agentid ? this.$route.query.agentid : ''}`;
      ShowTaskRewardLogListMember(this.myParam)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.rows);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让lastid等于最后数据的productAgentId
      if (this.myData.list.length && this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
  },
  filters: {
    num(val) {
      const valStr = val.toString();
      if (valStr.length < 3) {
        return `0.${val.toString().substr(-2)}`;
      } else {
        return `${val.toString().substring(0, val.toString().length - 2)}.${val.toString().substr(-2)}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.agent-info-box {
  &:nth-child(2) {
    margin-top: 0.75rem !important;
    background-color: #fff;
  }
}
</style>
